import { ReactNode } from 'react';

interface Props {
  num: string;
  title: string;
  icon: ReactNode;
  children: ReactNode;
}

export function SectionCard({ num, title, icon, children }: Props) {
  return (
    <section
      className="bg-white border border-[var(--line,rgba(15,30,51,0.08))] rounded-2xl mb-3 overflow-hidden"
      style={{ boxShadow: 'var(--shadow-card)' }}
    >
      <header
        className="flex items-center px-4 py-3 gap-2.5 border-b border-[var(--line,rgba(15,30,51,0.06))]"
        style={{
          background: 'linear-gradient(135deg, rgba(34,211,238,0.025), rgba(45,127,249,0.025))',
        }}
      >
        <span
          className="font-mono text-[10px] font-bold tracking-wider px-2 py-1 rounded text-[var(--brand-primary,#22D3EE)]"
          style={{
            background: 'var(--brand-navy,#0A1128)',
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          {num}
        </span>
        <h2
          className="flex-1 text-[15px] font-bold text-[var(--ink,#0F1E33)]"
          style={{ fontFamily: 'var(--brand-font-display)' }}
        >
          {title}
        </h2>
        <span
          className="text-[var(--brand-primary,#22D3EE)] flex items-center justify-center"
          style={{ width: '24px', height: '24px' }}
          aria-hidden="true"
        >
          {icon}
        </span>
      </header>
      <div className="p-4">{children}</div>
    </section>
  );
}
